import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Story } from "@/components/landing/Story";
import { Products } from "@/components/landing/Products";
import { Gallery } from "@/components/landing/Gallery";
import { StudioRefs } from "@/components/landing/StudioRefs";
import { Calculator } from "@/components/landing/Calculator";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Story />
      <Products />
      <Gallery />
      <StudioRefs />
      <Calculator />
      <Footer />
    </main>
  );
}
